import { Button, ButtonGroup, buttonName, useItemNames } from '@ps-smart-cp/ppfw-client';

interface Props {
  onRegistrationClick: () => void;
  onResetClick: () => void;
}

export function OutputFooterButtons({ onRegistrationClick, onResetClick }: Props) {
  const getButtonName = useItemNames(buttonName);

  return (
    <ButtonGroup alignment="right">
      <Button label={getButtonName('creationInstruction')} onClick={onRegistrationClick} />
      <Button label={getButtonName('reset')} onClick={onResetClick} />
    </ButtonGroup>
  );
}
